<template>
  <b-container v-if="platform">
    <h1 v-translate>Manage Integrations</h1>
    <div class="row">
      <div class="col-md-9 personal-info">
        <b-alert
          :show="dismissCountDown"
          dismissible
          variant="success"
          @dismissed="dismissCountDown = 0"
          @dismiss-count-down="countDownChanged"
        >
          <h5 v-translate>Integration settings were updated!</h5>
        </b-alert>
      </div>
      <div class="card">
        <div class="card-header">
          <translate>Configuration Panel</translate>
        </div>
        <div class="card-body">
          <form @submit.prevent="setVtexSettings()">
            <!-- Token -->
            <div class="form-group mb-3">
              <label v-translate>Vtex key</label>
              <input
                type="text"
                class="form-control"
                v-model="form.token"
                required
                placeholder="vtexappkey-moova-"
              />
            </div>

            <!-- Refresh Token -->
            <div class="form-group mb-3">
              <label v-translate>Vtex token</label>
              <input
                type="text"
                class="form-control"
                v-model="form.refreshToken"
                required
                placeholder="1234567890"
              />
            </div>

            <!-- External Store ID -->
            <div class="form-group mb-3">
              <label v-translate>Vtex host</label>
              <input
                type="text"
                class="form-control"
                v-model="form.externalStoreId"
                required
                placeholder="moova.myvtex.com"
              />
            </div>

            <hr/>

            <h5 class="mt-4 mb-3" v-translate>Metadata</h5>

            <!-- Set To Ready -->
            <div class="form-group mb-3">
              <label v-translate>Set To Ready</label>
              <b-form-select
                v-model="form.metadata.setToReady"
                class="form-control"
                :options="setToReadyOptions"
                placeholder="auto"
              />
              <small class="form-text text-muted" v-translate>
                Defines when orders are marked as ready
              </small>
            </div>

            <!-- Shipping Types -->
            <div class="form-group mb-3">
              <label v-translate>Shipping Types</label>

              <div
                v-for="(key, index) in Object.keys(form.metadata.shippingType)"
                :key="index"
                class="input-group mb-2"
              >
                <input
                  type="text"
                  class="form-control col-5"
                  :value="keyList[index]"
                  @input="updateShippingKey($event, index)"
                  placeholder="Shipping key (e.g., express)"
                />

                <b-form-select
                  v-model="form.metadata.shippingType[keyList[index]]"
                  :options="shippingTypeOptions"
                  class="col-3 ml-3"
                  required
                >
                </b-form-select>

                <button
                  type="button"
                  class="btn btn-danger ml-3"
                  @click="removeShippingType(index)"
                >
                  -
                </button>
              </div>

              <button
                type="button"
                class="btn btn-outline-primary ml-2"
                @click="addShippingType"
                :disabled="
                  Object.keys(form.metadata.shippingType).length >=
                  shippingTypeOptions.length
                "
              >
                <translate>Add</translate> +
              </button>
            </div>

            <!-- Submit -->
            <div class="form-group mt-4">
              <button type="submit" class="btn btn-success">
                <translate>Save</translate>
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  </b-container>
</template>
<script>
import AddressMixins from '@/mixins/address.mixin.js'
import CompanyNavigation from '@/components/CompanyNavigation'
import UserShippingTypeCard from '@/components/UserShippingTypeCard'
import LocationIntegrationCard from '@/components/LocationIntegrationCard'
import IntegrationImportShopifyShippingsMessage from '@/components/IntegrationImportShopifyShippingsMessage'
import AddressAutocomplete from '@/components/AddressAutocomplete'
import PlacePicker from '@/components/PlacePicker'
import { mapGetters } from 'vuex'

export default {
  name: 'VtexSettingsPage',
  components: {
    CompanyNavigation,
    UserShippingTypeCard,
    LocationIntegrationCard,
    IntegrationImportShopifyShippingsMessage,
    AddressAutocomplete,
    PlacePicker
  },
  data() {
    return {
      platformSlug: 'vtex',
      platform: {},
      form: {
        token: '',
        refreshToken: '',
        externalStoreId: '',
        metadata: {
          setToReady: '',
          shippingType: {}
        }
      },
      setToReadyOptions: [
        { value: null, text: 'Manually' },
        { value: 'order-completed', text: 'Order Completed' },
        { value: 'handling', text: 'Handling' },
        { value: 'ready-for-handling', text: 'Ready for Handling' },
        { value: 'cancel', text: 'Cancel' },
        { value: 'invoiced', text: 'Invoiced' }
      ],
      keyList: [],
      shippingTypeOptions: ['regular', 'next_day'],
      showDeliveryDay: true,
      dismissSecs: 10,
      success: this.$route.query.success ? this.$route.query.success : 0,
      message: this.$route.query.message ? this.$route.query.message : '',
      shipmentsCount: this.$route.query.shipmentsCount
        ? this.$route.query.shipmentsCount
        : null,
      dismissCountDown: 0,
      fields: [
        {
          key: 'external_link',
          label: this.$gettext('Platform link')
        }
      ]
    }
  },
  computed: {
    ...mapGetters(['user'])
  },
  mixins: [AddressMixins],
  mounted() {
    if (this.$route.query.creation) {
      this.$refs.IntegrationImportShopifyShippingsMessage.show()
    }

    this.microserviceFetch()
  },
  methods: {
    addShippingType() {
      const key = `id de vtex ${
        Object.keys(this.form.metadata.shippingType).length + 1
      }`
      this.$set(this.form.metadata.shippingType, key, '')
      this.keyList.push(key)
    },
    removeShippingType(index) {
      const key = this.keyList[index]
      this.$delete(this.form.metadata.shippingType, key)
      this.keyList.splice(index, 1)
    },
    updateShippingKey(event, index) {
      const newKey = event.target.value.trim()
      const oldKey = this.keyList[index]
      if (newKey === oldKey) return

      if (Object.prototype.hasOwnProperty.call(this.form.metadata.shippingType, newKey)) {
        alert('That key already exists.')
        event.target.value = oldKey
        return
      }

      const value = this.form.metadata.shippingType[oldKey]

      // delete the old key and set the new one
      this.$delete(this.form.metadata.shippingType, oldKey)
      this.$set(this.form.metadata.shippingType, newKey, value)

      // update local key list
      this.$set(this.keyList, index, newKey)
    },
    successUpdating() {
      this.dismissCountDown = this.dismissSecs
    },
    countDownChanged(dismissCountDown) {
      this.dismissCountDown = dismissCountDown
    },
    async getApplication() {
      const { data: response } = await this.$http.get(
        this.$appConfig.api.baseUrl + 'platforms'
      )
      const platforms = response.data
      this.platform = platforms.find((x) => x.slug === this.platformSlug)
      let applicationCanBeReused = null
      for (const app of this.$store.getters.profile.company.applications) {
        if (app.platform && app.platform.id === this.platform.id) {
          if (!app.webhook_url) {
            applicationCanBeReused = app
            continue
          }
          const urlObj = new URL(app.webhook_url)
          const params = new URLSearchParams(urlObj.search)
          if (params.get('userId') === String(this.user.id)) {
            this.application = app
            return
          }
        }
      }
      this.application = applicationCanBeReused
      return null
    },

    async setVtexSettings() {
      if (!this.application) {
        this.application = await this.generateApplication()
      }
      this.form = {
        ...this.form,
        countryIsoCode: this.user.company.country_iso_code,
        companyId: String(this.user.company.id),
        appId: this.application.id,
        appKey: this.application.key,
        externalUserId: String(this.user.id),
        ecosystemId: (this.siteName || '').toLowerCase()
      }
      if (this.form.metadata) this.form.metadata.ecosystemName = this.siteName
      const path =
        this.$appConfig.integrations.ecommerce.baseUrl +
        'vtex/authenticate?appId=' +
        this.application.id
      const headers = {
        'x-api-key': this.$appConfig.integrations.ecommerce.header,
        Authorization: this.application.key
      }
      await this.$http.post(path, this.form, { headers })
      await this.successUpdating()
    },
    async generateApplication() {
      const payload = {
        name: this.user.company.name + ' ' + this.platform.name,
        company_id: this.user.company_id,
        platform_id: this.platform.id,
        active: true
      }
      const { data } = await this.$http.post(
        this.$appConfig.api.baseUrl + 'applications',
        payload
      )
      return data
    },

    async microserviceFetch() {
      await this.getApplication()
      if (!this.application) return
      const path =
        this.$appConfig.integrations.ecommerce.baseUrl +
        'vtex/get-store?appId=' +
        this.application.id
      const headers = {
        'x-api-key': this.$appConfig.integrations.ecommerce.header,
        Auth: this.application.key
      }
      const { data } = await this.$http.get(path, { headers })
      if (!data) return
      this.form = {
        ...data,
        metadata: {
          setToReady: data.metadata.setToReady,
          shippingType: data.metadata.shippingType || {}
        }
      }

      for (const key in data.metadata.shippingType) {
        this.keyList.push(key)
      }
    }
  }
}
</script>
